import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import {
  deleteManyProviderIn,
  deleteProviderIn,
  getProviderIns,
  updateProvidedReceiptStatus,
  uploadFileForManyReceipts,
} from "store/provider-in/provider-in-action"
import ProviderInListComponent from "components/ProviderIn/list"
import SAlert from "components/Alert"
import {
  getProviderCommodityClassifications,
  getProviderCurrencies,
  getProviderFundCodes,
  getProviderIps,
  getProviderItemCategories,
  getProviderProjects,
  getProviderShipments,
} from "store/provider-dashboard/provider-dashboard-action"
import useSearch from "hooks/useSearch"
import ProviderInDetailModal from "components/ProviderIn/details"
import ReceiptsListModal from "components/ProviderIn/ReceiptsListModal"
import TransferModal from "components/ProviderTransfer/TransferModal"
import { exportProviderReceiptReport } from "store/provider-reports/p-report-action"
import {
  getProviderTransferInfo,
  createProviderTransfer,
} from "store/provider-transfer/provider-transfer-action"

const ProviderInList = () => {
  // Meta Title
  document.title = "Receipts"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.providerIn)
  const { transferInfo } = useSelector(state => state.providerTransfer)
  const permissions = useSelector(state => state.auth.permissions)
  const [deleteModal, setDeleteModal] = useState(false)
  const [proIn, setProIn] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)
  const [receiptsModal, setReceiptsModal] = useState(false)
  const [selectedReceipt, setSelectedReceipt] = useState(null)
  const [transferModal, setTransferModal] = useState(false)
  const [selectedTransferReceipt, setSelectedTransferReceipt] = useState(null)

  // Current status of the export process for the report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.providerReports.providerExportReceiptReport
  )

  const {
    data: providedStatusResult,
    loading: provideStatusLoading,
    error: ProvidedStatusError,
  } = useSelector(state => state.providerIn.ProvidedStatus)

  // Handle record deletion and close the delete modal
  // Dispatch delete action for the selected record
  // Close the delete modal
  const handleDeleteFunc = data => {
    if (proIn) {
      dispatch(deleteProviderIn(proIn.id))
    }
    setDeleteModal(false)
  }

  // Handle multiple delete action when top delete button is clicked
  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(deleteManyProviderIn(ids))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }

  // Dispatches uploadFileForManyReceipts to upload a file associated with multiple receipts
  const onUploadFileForMultipleReceipts = (ids, file) => {
    if (ids.length > 0) {
      console.log(file)
      const form = new FormData()
      form.append("ids", JSON.stringify(ids))
      form.append("document", file)
      dispatch(uploadFileForManyReceipts(form))
      SAlert({ text: "Upload Scucessfully" })
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }

  // Set the record to be deleted and open the delete modal
  // Store the selected record for deletion
  // Open the delete confirmation modal
  const onClickDelete = data => {
    setProIn(data)
    setDeleteModal(true)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProviderIns(link.url, pageNumber, according, search, advnacedSearch)
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Rejects a Provider to Provider receipt by updating its status to "Reject"
  const onRejectReceipt = data => {
    dispatch(updateProvidedReceiptStatus(data?.id, "Reject"))
  }

  // Accepts a Provider to Provider receipt by opening modal
  const onAcceiptReceipt = data => {
    if (data?.provided_by?.distribution_reason === "Exchange") {
      setSelectedReceipt(data)
      setReceiptsModal(true)
    } else {
      dispatch(updateProvidedReceiptStatus(data?.id, "Accept"))
    }
  }

  // Handle successful receipt acceptance
  const onReceiptAcceptSuccess = () => {
    dispatch(
      getProviderIns(undefined, pageNumber, according, search, advnacedSearch)
    )
    setReceiptsModal(false)
    setSelectedReceipt(null)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProviderIns(undefined, undefined, undefined, search, advnacedSearch),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProviderIns(undefined, pageNumber, according, search, advnacedSearch)
    )
  }, [pageNumber, according])

  // fetch items categories, projects, IPs, Currencies
  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderProjects())
    dispatch(getProviderIps())
    dispatch(getProviderCurrencies())
    dispatch(getProviderShipments())
    dispatch(getProviderFundCodes())
    dispatch(getProviderCommodityClassifications())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getProviderIns(undefined, undefined, undefined, search, data))
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(
      exportProviderReceiptReport(pageNumber, according, search, advnacedSearch)
    )
  }

  // Show record details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setProIn(data)
    setDetailModal(true)
  }

  // Handle Transfer button click on Other Source receipt
  const onTransferClick = data => {
    setSelectedTransferReceipt(data)
    dispatch(getProviderTransferInfo(data.id))
    setTransferModal(true)
  }

  // Handle transfer proceed - sends entire available qty
  const onTransferProceed = qty => {
    if (!selectedTransferReceipt) return
    dispatch(
      createProviderTransfer(
        { provider_in_id: selectedTransferReceipt.id, transfer_qty: qty },
        success => {
          if (success) {
            setTransferModal(false)
            setSelectedTransferReceipt(null)
            dispatch(
              getProviderIns(
                undefined,
                pageNumber,
                according,
                search,
                advnacedSearch
              )
            )
          }
        }
      )
    )
  }

  // Handle transfer modal toggle
  const onTransferToggle = () => {
    setTransferModal(!transferModal)
    if (!transferModal) {
      setSelectedTransferReceipt(null)
    }
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <ProviderInDetailModal
        data={proIn}
        open={detailModal}
        setOpen={setDetailModal}
      />
      <ReceiptsListModal
        isOpen={receiptsModal}
        toggle={() => setReceiptsModal(false)}
        receiptData={selectedReceipt}
        onSuccess={onReceiptAcceptSuccess}
      />
      <TransferModal
        isOpen={transferModal}
        toggle={onTransferToggle}
        transferInfo={transferInfo?.data}
        loading={transferInfo?.loading}
        onProceed={onTransferProceed}
      />
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Receipts"} />

      {/* Provider receipt List Component  */}
      <ProviderInListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        permissions={permissions}
        onClickDetail={onClickDetail}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        onUploadFileForMultipleReceipts={onUploadFileForMultipleReceipts}
        onRejectReceipt={onRejectReceipt}
        onAcceiptReceipt={onAcceiptReceipt}
        onTransferClick={onTransferClick}
      />
    </React.Fragment>
  )
}

export default ProviderInList
